module.exports = __webpack_public_path__ + "img/site-normal.a7ca4b5d.svg";